import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { MedicationBlueLabelAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-medication-blue-label-slot',
    templateUrl: './medication-blue-label-slot.component.html',
    styleUrl: './medication-blue-label-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedicationBlueLabelSlotComponent implements SheetSlotComponentBase {

	action!: MedicationBlueLabelAction;
	value!: string | null;

	@Input('action') set updateAction(action: MedicationBlueLabelAction | null) {
		this.action = action as MedicationBlueLabelAction;
		this.value = this.action.dose?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}